import { Box, Grid, Paper, Tooltip, Typography } from "@mui/material";
import React, { useState } from "react";
import editbox from "../../Utils/Images/editbox.png";
import deletebox from "../../Utils/Images/deletebox.png";
import { handleDeleteVoucher } from "../../APIs/Function/Voucher/DeleteVoucher";
import { Link } from "react-router-dom";
import DeleteModal from "../Modal/DeleteModal";
import { GetVoucher } from "../../APIs/Function/Voucher/GetVoucher";
import Loader from "../Loader/Loader";

const VoucherTable = ({ setVoucherData, voucherData, loadinga }) => {
  const [modalID, setModalID] = useState("");
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    setLoading(true);
    await handleDeleteVoucher(modalID);
    setLoading(false);
    let res = await GetVoucher();
    setVoucherData(res.r);
    alert("Voucher Deleted Successfully");
    setOpen(false);
  };
  const handleModal = (id) => {
    setModalID(id);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      {loadinga ? (
        <Box sx={{ mt: "25%" }}>
          <Loader />
        </Box>
      ) : (
        <Box>
          {/* heading */}
          <Box
            sx={{
              boxShadow: "none",
              outline: "none",
              mb: "10px",
              border: "none",
              mt: "10px",
              boxSizing: "border-box",
            }}
          >
            <Grid container>
              {/* first column */}
              <Grid item xs={0.5} md={0.5}>
                <Paper
                  sx={{
                    borderRadius: "0px",
                    border: "0.5px solid #DDDDDD",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                    bgcolor: "#E6E6E6",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",
                      opacity: "85%",
                      color: "#252525",
                    }}
                  >
                    #
                  </Typography>
                </Paper>
              </Grid>
              {/* Second Column */}
              <Grid item xs={1.5} md={1.5}>
                <Paper
                  sx={{
                    borderRadius: "0px",
                    border: "0.5px solid #DDDDDD",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                    bgcolor: "#E6E6E6",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",
                      opacity: "85%",
                      color: "#252525",
                    }}
                  >
                    Clip Art
                  </Typography>
                </Paper>
              </Grid>
              {/* Third Column */}
              <Grid item xs={2} md={2}>
                <Paper
                  sx={{
                    borderRadius: "0px",
                    border: "0.5px solid #DDDDDD",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                    bgcolor: "#E6E6E6",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",

                      opacity: "85%",
                      color: "#252525",
                    }}
                  >
                    Title
                  </Typography>
                </Paper>
              </Grid>
              {/* Fourth Column */}
              <Grid item xs={2} md={2}>
                <Paper
                  sx={{
                    borderRadius: "0px",
                    border: "0.5px solid #DDDDDD",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                    bgcolor: "#E6E6E6",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",
                      opacity: "85%",
                      color: "#252525",
                    }}
                  >
                    Description
                  </Typography>
                </Paper>
              </Grid>
              {/* fifth Column */}
              <Grid item xs={2} md={2.5}>
                <Paper
                  sx={{
                    borderRadius: "0px",
                    border: "0.5px solid #DDDDDD",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                    bgcolor: "#E6E6E6",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",

                      opacity: "85%",
                      color: "#252525",
                    }}
                  >
                    Code
                  </Typography>
                </Paper>
              </Grid>
              {/* Sixth Column */}
              <Grid item xs={2} md={2}>
                <Paper
                  sx={{
                    borderRadius: "0px",
                    border: "0.5px solid #DDDDDD",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                    bgcolor: "#E6E6E6",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",

                      opacity: "85%",
                      color: "#252525",
                    }}
                  >
                    Link
                  </Typography>
                </Paper>
              </Grid>
              {/* Seventh Column */}
              <Grid item xs={2} md={1.5}>
                <Paper
                  sx={{
                    borderRadius: "0px",
                    border: "0.5px solid #DDDDDD",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                    bgcolor: "#E6E6E6",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",

                      opacity: "85%",
                      color: "#252525",
                    }}
                  >
                    Action
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Box>
          <Box
            sx={{
              border: "1px solid #DDDDDD",
              height: "100%",
              overflow: "auto",
              mt: "10px",
              borderTop: "0.5px solid #DDDDDD",
              maxHeight: "75vh",
              "&:hover": {
                "::-webkit-scrollbar": {
                  width: "5px",
                  borderRadius: "10px",
                },
                "::-webkit-scrollbar-thumb": {
                  bgcolor: "gray",
                  borderRadius: "10px",
                },
              },
            }}
          >
            <Box>
              <Grid container>
                {/* first column */}
                <Grid item xs={0.5} md={0.5}>
                  {voucherData.map((item, i) => (
                    <Paper
                      sx={{
                        border: "0.5px solid #DDDDDD",
                        borderRadius: "0px",
                        height: "70px",
                        display: "flex",
                        alignItems: "center",
                        textAlign: "center",
                        justifyContent: "center",
                      }}
                      key={i}
                    >
                      <Typography
                        sx={{
                          fontFamily: "inter",
                          fontWeight: "400",
                          fontSize: "16px",
                        }}
                      >
                        {i + 1}
                      </Typography>
                    </Paper>
                  ))}
                </Grid>

                {/* Second Column */}

                <Grid item xs={1.5} md={1.5}>
                  {voucherData.map((item, i) => (
                    <Paper
                      sx={{
                        border: "0.5px solid #DDDDDD",
                        borderRadius: "0px",
                        height: "70px",
                        display: "flex",
                        alignItems: "center",
                        textAlign: "center",
                        justifyContent: "center",
                        bgcolor: i % 2 === 0 ? "#FFFFFF" : "#fbfbfb",
                      }}
                      key={i}
                    >
                      <img
                        width={"51px"}
                        height={"51px"}
                        style={{ borderRadius: "10px" }}
                        src={`https://api-qhealth.equitysofttechnologies.com/upload/images/${item.image}`}
                        alt=""
                      />
                    </Paper>
                  ))}
                </Grid>

                {/* Third Column */}

                <Grid item xs={2} md={2}>
                  {voucherData.map((item, i) => (
                    <Paper
                      sx={{
                        border: "0.5px solid #DDDDDD",
                        borderRadius: "0px",
                        height: "70px",
                        display: "flex",
                        alignItems: "center",
                        textAlign: "center",
                        justifyContent: "center",
                        bgcolor: i % 2 === 0 ? "#FFFFFF" : "#fbfbfb",
                      }}
                      key={i}
                    >
                      <Typography
                        sx={{
                          fontFamily: "inter",
                          fontWeight: "400",
                          fontSize: "16px",

                          textOverflow: "ellipsis",
                          overflow: "hidden",
                          maxWidth: "90%",
                          "&:hover": {
                            overflow: "visible",
                          },
                        }}
                      >
                        {item.name}
                      </Typography>
                    </Paper>
                  ))}
                </Grid>

                {/* Fourth Column */}

                <Grid item xs={2} md={2}>
                  {voucherData.map((item, i) => (
                    <Paper
                      sx={{
                        border: "0.5px solid #DDDDDD",
                        borderRadius: "0px",
                        height: "70px",
                        display: "flex",
                        alignItems: "center",
                        textAlign: "center",
                        justifyContent: "center",
                        bgcolor: i % 2 === 0 ? "#FFFFFF" : "#fbfbfb",
                      }}
                      key={i}
                    >
                      <Tooltip title={item.description} arrow>
                        <Typography
                          noWrap
                          sx={{
                            cursor: "pointer",
                            m: "auto",
                            fontFamily: "inter",
                            fontWeight: "400",
                            fontSize: "16px",
                            width: "150px",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {item.description}
                        </Typography>{" "}
                      </Tooltip>
                    </Paper>
                  ))}
                </Grid>
                {/* fifth Column */}
                <Grid item xs={2} md={2.5}>
                  {voucherData.map((item, i) => (
                    <Paper
                      sx={{
                        border: "0.5px solid #DDDDDD",
                        borderRadius: "0px",
                        height: "70px",
                        display: "flex",
                        alignItems: "center",
                        textAlign: "center",
                        justifyContent: "center",
                        bgcolor: i % 2 === 0 ? "#FFFFFF" : "#fbfbfb",
                      }}
                      key={i}
                    >
                      <Typography
                        sx={{
                          fontFamily: "inter",
                          fontWeight: "400",
                          fontSize: "16px",

                          textOverflow: "ellipsis",
                          overflow: "hidden",
                          maxWidth: "90%",
                          "&:hover": {
                            overflow: "visible",
                          },
                        }}
                      >
                        {item.code}
                      </Typography>
                    </Paper>
                  ))}
                </Grid>
                {/* Sixth Column */}
                <Grid item xs={2} md={2}>
                  {voucherData.map((item, i) => (
                    <Paper
                      sx={{
                        border: "0.5px solid #DDDDDD",
                        borderRadius: "0px",
                        height: "70px",
                        display: "flex",
                        alignItems: "center",
                        textAlign: "center",
                        justifyContent: "center",
                        bgcolor: i % 2 === 0 ? "#FFFFFF" : "#fbfbfb",
                      }}
                      key={i}
                    >
                      {" "}
                      <Tooltip title={item.link} arrow>
                        <Typography
                          sx={{
                            fontFamily: "inter",
                            fontWeight: "400",
                            fontSize: "16px",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            maxWidth: "90%",
                            "&:hover": {
                              overflow: "visible",
                            },
                          }}
                        >
                          {item.link}
                        </Typography>
                      </Tooltip>
                    </Paper>
                  ))}
                </Grid>
                {/* Seventh Column */}
                <Grid item xs={2} md={1.5}>
                  {voucherData.map((e, i) => (
                    <Paper
                      sx={{
                        border: "0.5px solid #DDDDDD",
                        borderRadius: "0px",
                        height: "70px",
                        display: "flex",
                        alignItems: "center",
                        textAlign: "center",
                        justifyContent: "center",
                        bgcolor: i % 2 === 0 ? "#FFFFFF" : "#fbfbfb",
                      }}
                    >
                      <Box
                        sx={{
                          p: 1,
                          display: "Flex",
                          width: "100%",
                          justifyContent:"space-around",
                        }}
                      >
                        <Box
                          sx={{
                            cursor: "pointer",
                            width: "40px",
                            height: "40px",
                          }}
                        >
                          <img
                            width={"100%"}
                            height={"100%"}
                            src={deletebox}
                            alt=""
                            onClick={() => handleModal(e.id)}
                          />
                        </Box>
                        <Box
                          sx={{
                            cursor: "pointer",
                            width: "40px",
                            height: "40px",
                          }}
                        >
                          <Link to={`/voucherdetails/${e.id}`}>
                            <img
                              width={"100%"}
                              height={"100%"}
                              src={editbox}
                              alt=""
                            />
                          </Link>
                        </Box>
                      </Box>
                    </Paper>
                  ))}
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>
      )}
      <DeleteModal
        open={open}
        handleDelete={handleDelete}
        modalID={modalID}
        onClose={handleClose}
      />
    </>
  );
};

export default VoucherTable;
